import { render, staticRenderFns } from "./container-content-wrapper.vue?vue&type=template&id=df1d3416&scoped=true&"
import script from "./container-content-wrapper.vue?vue&type=script&lang=ts&"
export * from "./container-content-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./container-content-wrapper.vue?vue&type=style&index=0&id=df1d3416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1d3416",
  null
  
)

export default component.exports